import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatType, IChatItem, IProfile, IResponse } from '@interfaces/index';
import { AppService } from '../../services/app.service';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: [
    './chat-box.component.scss',
    './ollie-box/ollie-box.component.scss'
  ]
})
export class ChatBoxComponent implements OnInit {
  loading = false;
  refreshLoading = false;
  thumbsUpActive: boolean = false;
  thumbsDownActive: boolean = false;
  userProfile: IProfile | null = null;

  constructor(protected _app_service: AppService, private _cdr: ChangeDetectorRef) { }

  @Input() chat: IChatItem | null = null;
  @Input() content_array: string[] = [];
  @Input() isStreaming: boolean = false;
  @Input() isLast: boolean = false;

  @Output() refreshRequested: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit(): void {
    this.loading = true;

    this._app_service.getProfile().subscribe({
      next: (response: IResponse<IProfile>) => {
        this.userProfile = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this._app_service.notify('Failed to fetch profile. Please try again later.', 'error');
        console.error('Error fetching profile:', error);
        this.loading = false;
      }
    });
  }

  get isOllieMessage(): boolean {
    return this.chat?.type_id === ChatType.Ollie;
  }

  get isPerson(): boolean {
    return this.chat?.type_id === ChatType.Person;
  }

  get isOllieHelp(): boolean {
    return this.chat?.type_id === ChatType.OllieHelp;
  }

  get messageType(): 'person' | 'ollie' | 'ollieHelp' {
    if (this.isOllieHelp) return 'ollieHelp';
    if (this.isPerson) return 'person';
    return 'ollie';
  }

  get actionButtons() {
    return [
      {
        icon: 'thumb_up',
        class: 'thumbs-up',
        aria: 'Give thumbs up',
        active: this.thumbsUpActive,
        action: () => this.onThumbsUp(),
      },
      {
        icon: 'thumb_down',
        class: 'thumbs-down',
        aria: 'Give thumbs down',
        active: this.thumbsDownActive,
        action: () => this.onThumbsDown(),
      }
    ];
  }

  onThumbsUp() {
    this.thumbsUpActive = !this.thumbsUpActive;
    this.thumbsDownActive = false;
    this._cdr.detectChanges();
  }

  onThumbsDown() {
    this.thumbsDownActive = !this.thumbsDownActive;
    this.thumbsUpActive = false;
    this._cdr.detectChanges();
  }

  copyAll() {
    if (!this.content_array.length) return;
    const allQuestions = this.content_array.join('\n');
    this.copyText(allQuestions);
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text).then(() => { });
  }

  refresh() {
    this.refreshLoading = true;
    this._cdr.detectChanges();
    this.refreshRequested.emit(this.chat?.message_id);
    this.refreshLoading = false;
  }
}
